module.exports = __webpack_public_path__ + "img/rns.d270ea1e.png";